export default {
  复制配送接口: '复制配送接口',
  复制货主接口: '复制货主接口',
  '导入{interfaceType }数据': '导入{interfaceType }数据',
  导入: '导入',
  导出: '导出',
  接口文档: '接口文档',
  复制成功: '复制成功',
  导入成功: '导入成功',
  编辑: '编辑',
  复制: '复制',
  '接口配置：{name}': '接口配置：{name}',
  导出失败: '导出失败',
  '操作成功！': '操作成功！',
  删除: '删除',
  导出数据: '导出数据',
  请输入配送中心: '请输入配送中心',
  配送中心: '配送中心',
  请输入接口名称: '请输入接口名称',
  操作失败: '操作失败',
  操作: '操作',
  报警钉钉: '报警钉钉',
  阻塞个数: '阻塞个数',
  待执行个数: '待执行个数',
  执行时间: '执行时间',
  执行策略: '执行策略',
  确认: '确认',
  '确认取消调试该接口吗？': '确认取消调试该接口吗？',
  '确认调试该接口吗？': '确认调试该接口吗？',
  调试: '调试',
  '确认禁用该接口吗？': '确认禁用该接口吗？',
  '确认启用该接口吗？': '确认启用该接口吗？',
  状态: '状态',
  货主: '货主',
  请选择Erp配置: '请选择Erp配置',
  Erp配置: 'Erp配置',
  Erp配置不能为空: 'Erp配置不能为空',
  请选择目标配送中心: '请选择目标配送中心',
  目标配送中心: '目标配送中心',
  目标配送中心不能为空: '目标配送中心不能为空',
  请选择来源配送中心: '请选择来源配送中心',
  来源配送中心: '来源配送中心',
  来源配送中心不能为空: '来源配送中心不能为空',
  请选择目标货主: '请选择目标货主',
  目标货主: '目标货主',
  目标货主不能为空: '目标货主不能为空',
  请选择来源货主: '请选择来源货主',
  来源货主: '来源货主',
  来源货主不能为空: '来源货主不能为空',
  请输入数据: '请输入数据',
  数据不能为空: '数据不能为空',
  数据: '数据',
  请选择钉钉配置: '请选择钉钉配置',
  钉钉配置: '钉钉配置',
  请选择Erp配置: '请选择Erp配置',
  Erp配置不为空: 'Erp配置不为空',
  Erp配置: 'Erp配置',
  '<空>': '<空>',
  执行时间: '执行时间',
  导出结果: '导出结果',
  返回: '返回',
  '导出{interfaceType}': '导出{interfaceType}',
  确定: '确定',
  '欢迎使用！': '欢迎使用！',
  保存: '保存',
  新建: '新建',
  明细: '明细',
  请输入备注: '请输入备注',
  备注: '备注',
  请输入后置过滤: '请输入后置过滤',
  后置过滤: '后置过滤',
  请输入前置过滤: '请输入前置过滤',
  前置过滤: '前置过滤',
  请输入执行时间: '请输入执行时间',
  执行时间: '执行时间',
  '必须是HH:mm格式': '必须是HH:mm格式',
  执行时间不能为空: '执行时间不能为空',
  必须是正整数: '必须是正整数',
  请输入执行策略: '请输入执行策略',
  执行策略不能为空: '执行策略不能为空',
  接口地址: '接口地址',
  请输入中间表名: '请输入中间表名',
  中间表名: '中间表名',
  中间表名不能超过30: '中间表名不能超过30',
  中间表名不能为空: '中间表名不能为空',
  数据表达式: '数据表达式',
  反馈表达式: '反馈表达式',
  反馈类型: '反馈类型',
  接口路径: '接口路径',
  接口路径不能为空: '接口路径不能为空',
  接口类型: '接口类型',
  接口类型不能为空: '接口类型不能为空',
  路径: '路径',
  地址: '地址',
  地址不能为空: '地址不能为空',
  拼接别名: '拼接别名',
  接口名称: '接口名称',
  接口名长度不能超过30: '接口名长度不能超过30',
  接口名称不能为空: '接口名称不能为空',
  概要: '概要',
  钉钉配置不能为空: '钉钉配置不能为空',
  数组: '数组',
  '第{line}行功能类型不能为空': '第{line}行功能类型不能为空',
  '第{line}行功能类型为常规，来源字段不能为空':
    '第{line}行功能类型为常规，来源字段不能为空',
  '第{line}行功能类型为自定义或固定值，表达式不能为空':
    '第{line}行功能类型为自定义或固定值，表达式不能为空',
  '第{line}行功能类型为子表，表达式不能为空':
    '第{line}行功能类型为子表，表达式不能为空',
  '第{line}行功能类型为子表，来源字段不能为空':
    '第{line}行功能类型为子表，来源字段不能为空',
  修改成功: '修改成功',
  保存成功: '保存成功',
  行号: '行号',
  目标字段: '目标字段',
  类型: '类型',
  描述: '描述',
  功能类型: '功能类型',
  来源字段: '来源字段',
  表达式: '表达式',
  添加子级: '添加子级',
  '确认删除吗?': '确认删除吗?',
  确定: '确定',
  取消: '取消',
  '确认{operate}该{object}吗?': '确认{operate}该{object}吗?',
  '执行时间(min)': '执行时间(min)',
  最后调度时间: '最后调度时间',
  ERP配置: 'ERP配置',
  全部: '全部',
  实体: '实体',
  日志级别: '日志级别',
  日志类型: '日志类型',
  日志时间: '日志时间',
  '耗时(ms)': '耗时(ms)',
  数据: '数据',
  详情: '详情',
  请选择日志类型: '请选择日志类型',
  请输入实体: '请输入实体',
  开始时间: '开始时间',
  请选择时间: '请选择时间',
  取消执行成功: '取消执行成功',
  重置执行成功: '重置执行成功',
  调试执行成功: '调试执行成功',
  实体标识: '实体标识',
  最后执行时间: '最后执行时间',
  失败次数: '失败次数',
  失败原因: '失败原因',
  重置: '重置',
  调试: '调试',
  请输入实体标识: '请输入实体标识',
  请输入参数信息: '请输入参数信息',
  单号: '单号',
  单号不能为空: '单号不能为空',
  '请输入：单号': '请输入：单号',
  调试: '调试',
  上传: '上传',
  重置: '重置',
  请求信息: '请求信息',
  请求结果: '请求结果',
  接口详情: '接口详情',
  接口日志: '接口日志',
  待执行数据: '待执行数据',
  接口调试: '接口调试',
  当前网络不可用: '当前网络不可用',
  请求超时: '请求超时',
  接口平台配置: '接口平台配置',
  日结配置: '日结配置',
  安全配置: '安全配置',
  ERP配置: 'ERP配置',
  数据源配置: '数据源配置',
  认证配置: '认证配置',
  全局配置: '全局配置',
  请输入接口范围: '请输入接口范围',
  接口范围不能为空: '接口范围不能为空',
  接口范围: '接口范围',
  请输入取消天数范围: '请输入取消天数范围',
  取消天数范围不能为空: '取消天数范围不能为空',
  取消天数范围: '取消天数范围',
  请输入失败次数起始值: '请输入失败次数起始值',
  失败次数起始值不能为空: '失败次数起始值不能为空',
  失败次数起始值: '失败次数起始值',
  日结时间不能为空: '日结时间不能为空',
  日结时间: '日结时间',
  取消待执行数据: '取消待执行数据',
  请输入接口范围: '请输入接口范围',
  接口范围不能为空: '接口范围不能为空',
  接口范围: '接口范围',
  请输入重置天数范围: '请输入重置天数范围',
  重置天数范围不能为空: '重置天数范围不能为空',
  重置天数范围: '重置天数范围',
  重置待执行数据: '重置待执行数据',
  请输入: '请输入',
  请选择认证类型: '请选择认证类型',
  认证类型不能为空: '认证类型不能为空',
  认证类型: '认证类型',
  请输入名称: '请输入名称',
  名称不能为空: '名称不能为空',
  名称: '名称',
  删除成功: '删除成功',
  '认证配置：{name}': '认证配置：{name}',
  日结配置类型: '日结配置类型',
  请选择日结配置类型: '请选择日结配置类型',
  时间: '时间',
  请选择时间: '请选择时间',
  配置日志: '配置日志',
  日结日志: '日结日志',
  ERP类型: 'ERP类型',
  ERP类型不能为空: 'ERP类型不能为空',
  请选择ERP类型: '请选择ERP类型',
  基础路径: '基础路径',
  基础路径不能为空: '基础路径不能为空',
  请输入基础路径: '请输入基础路径',
  数据源配置不能为空: '数据源配置不能为空',
  请选择数据源配置: '请选择数据源配置',
  请选择认证配置: '请选择认证配置',
  'ERP配置：{name}': 'ERP配置：{name}',
  帮助文档: '帮助文档',
  开启: '开启',
  关闭: '关闭',
  '中间表->ERP不能为空': '中间表->ERP不能为空',
  '中间表->ERP': '中间表->ERP',
  'WMS->中间表不能为空': 'WMS->中间表不能为空',
  'WMS->中间表': 'WMS->中间表',
  '中间表->WMS不能为空': '中间表->WMS不能为空',
  '中间表->WMS': '中间表->WMS',
  'ERP->中间表不能为空': 'ERP->中间表不能为空',
  'ERP->中间表': 'ERP->中间表',
  接口鉴权: '接口鉴权',
  点我: '点我',
  请输入密码: '请输入密码',
  密码不能为空: '密码不能为空',
  密码: '密码',
  请输入用户名: '请输入用户名',
  用户名不能为空: '用户名不能为空',
  用户名: '用户名',
  请输入编码: '请输入编码',
  编码不能为空: '编码不能为空',
  编码: '编码',
  请输入数据库名称: '请输入数据库名称',
  数据库名称不能为空: '数据库名称不能为空',
  数据库名称: '数据库名称',
  请输入端口: '请输入端口',
  端口不能为空: '端口不能为空',
  端口: '端口',
  请输入IP: '请输入IP',
  IP不能为空: 'IP不能为空',
  请选择数据库类型: '请选择数据库类型',
  数据库类型不能为空: '数据库类型不能为空',
  数据库类型: '数据库类型',
  '数据源配置：{name}': '数据源配置：{name}',
  端口: '端口',
  IP: 'IP',
  编码: '编码',
  数据库: '数据库',
  数据库类型: '数据库类型',
  启用: '启用',
  禁用: '禁用',
  请输入失败次数: '请输入失败次数',
  请输入接口类型: '请输入接口类型',
  本日: '今日',
  本周: '本周',
  本年: '本年',
  本月: '本月',
  整体: '整体',
  接口待执行数据: '接口待执行数据',
  保质期: '保质期',
  '涉及字段：保质期类型、保质期': '涉及字段：保质期类型、保质期',
  控制天数: '控制天数',
  '涉及字段：收货控制天数、配货控制天数、退货控制天数':
    '涉及字段：收货控制天数、配货控制天数、退货控制天数',
  规格测量值: '规格测量值',
  '涉及字段：规格的长、宽、高、重': '涉及字段：规格的长、宽、高、重',
  计量单位: '计量单位',
  '涉及字段：规格的计量单位': '涉及字段：规格的计量单位',
  出货倍数: '出货倍数',
  '涉及字段：起要量、出货倍数': '涉及字段：起要量、出货倍数',
  默认规格: '默认规格',
  '涉及字段：默认规格': '涉及字段：默认规格',
  耗材标记: '耗材标记',
  原料上下限: '原料上下限',
  查询: '查询',
  重置: '重置',
  展开: '展开',
  收起: '收起',
  添加: '添加',
  删除: '删除',
  请选择货主: '请选择货主',
  货主不能为空: '货主不能为空',
  ERP下行: 'ERP下行',
  ERP上行: 'ERP上行',
  WCS下行: 'WCS下行',
  WCS上行: 'WCS上行',
  配送中心不能为空: '配送中心不能为空',
  请选择配送中心: '请选择配送中心',
  字符串: '字符串',
  数值型: '数值型',
  整数型: '整数型',
  日期: '日期',
  数组: '数组',
  对象: '对象',
  常规: '常规',
  拼接: '拼接',
  连接: '连接',
  截取: '截取',
  默认值: '默认值',
  取负数: '取负数',
  自定义: '自定义',
  替换: '替换',
  取当前时间: '取当前时间',
  格式化时间: '格式化时间',
  HTTP型: 'HTTP型',
  'Active MQ型': 'Active MQ型',
  webService型: 'webService型',
  中间表: '中间表',
  字符串: '字符串',
  '整型(INTEGER)': '整型(INTEGER)',
  '整型(INT)': '整型(INT)',
  长整型: '长整型',
  布尔型: '布尔型',
  数值型: '数值型',
  日期: '日期',
  数组: '数组',
  对象: '对象',
  上传: '上传',
  基本资料下发: '基本资料下发',
  单据下发: '单据下发',
  定时: '定时',
  轮询: '轮询',
  常规: '常规',
  自定义: '自定义',
  分组: '分组',
  固定值: '固定值',
  子表: '子表',
  子查询: '子查询',
  后置自定义: '后置自定义',
  API接口: 'API接口',
  是否回传限制: '是否回传限制',
  是否限制回传顺序: '是否限制回传顺序',
  是: '是',
  否: '否',
  请选择需要导出的数据: '请选择需要导出的数据',
  暂停: '暂停',
  动作: '动作',
  请求动作不能为空: '请求动作不能为空',
  表单id: '表单id',
  表单id不能为空: '表单id不能为空',
};
